<div class="text-center">
    <h1>{{msg}}</h1>
</div>
